import React from "react";
import { Link } from "react-router-dom";
import { Smartphone, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { staffHomePath } from "@/lib/staffAccess";

/** Schermata se uno staff prova ad aprire la cassa dal browser. */
export default function CassaApkOnly() {
  const { user, logout } = useAuth() || {};
  const home = staffHomePath(user);
  const hasDesk = home.startsWith("/dashboard") || home === "/palmare";

  return (
    <div className="min-h-screen bg-[#F7F7F8] flex items-center justify-center p-6" data-testid="cassa-apk-only">
      <div className="bg-white border border-[#E4E4E7] rounded-2xl p-8 max-w-md w-full text-center">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-[#B73C27]/10 text-[#B73C27] flex items-center justify-center">
          <Smartphone className="w-6 h-6" />
        </div>
        <h1 className="font-heading text-2xl font-semibold text-[#18181B] mb-2">Cassa solo sull&apos;app</h1>
        <p className="text-sm text-[#71717A] leading-relaxed">
          Il titolare ti ha abilitato la cassa sul tablet. Aprila dall&apos;app Velta One (APK), non da questa pagina web.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          {hasDesk && home !== "/cassa" && (
            <Link to={home} className="h-12 rounded-xl bg-[#18181B] text-white font-medium flex items-center justify-center">
              Vai alle tue pagine
            </Link>
          )}
          <button type="button" onClick={logout} className="h-12 rounded-xl border border-[#E4E4E7] text-[#3F3F46] font-medium inline-flex items-center justify-center gap-2">
            <LogOut className="w-4 h-4" /> Esci
          </button>
        </div>
      </div>
    </div>
  );
}
